import React from 'react';
import { useTranslation } from '../../i18n';
import {
    isMentalTestBaselineAvailable,
    mentalTestChartProps,
    renderCustomBarLabel,
} from '../../sections/CognitiveAbilitiesExplanation/CognitiveAbilitiesExplanation';
import {
    Bar,
    BarChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    XAxis,
} from 'recharts';
import { MentalTestScores } from '../../typings';
import './styles.css';

interface CognitiveAbilitiesBarChartProps {
    mentalTestScores: MentalTestScores | undefined;
    companyName: string;
}

const CognitiveAbilitiesBarChart = (props: CognitiveAbilitiesBarChartProps) => {
    const { mentalTestScores, companyName } = props;
    const { t } = useTranslation();

    const categoriesScore = mentalTestScores && mentalTestScores.categories;
    const chartProps = mentalTestChartProps(categoriesScore, t);
    const isBaselineAvailable = isMentalTestBaselineAvailable(chartProps);

    return (
        <div className="cognitiveAbilitiesBarChart">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={chartProps}
                    style={{fontSize:14}}
                    margin={{
                        top: 25,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}>
                    <CartesianGrid strokeDasharray="1 3" />
                    <Bar
                        fontSize={14}
                        barSize={35}
                        isAnimationActive={false}
                        dataKey="Your score"
                        name={`${t(
                            'COGNITIVE_ABILITIES_GRAPH.LEGEND_YOUR_SCORE',
                        )}`}
                        fill="#00a5ad"
                        label={renderCustomBarLabel}
                    />
                    {isBaselineAvailable && (
                        <Bar
                            fontSize={14}
                            barSize={35}
                            isAnimationActive={false}
                            dataKey="Company benchmark"
                            name={`${t(
                                'COGNITIVE_ABILITIES_GRAPH.LEGEND_COMPANY_BENCHMARK',
                                { company_name: companyName },
                            )}`}
                            fill="#D8D8D8"
                            label={renderCustomBarLabel}
                        />
                    )}
                    <XAxis dataKey="name" fontSize={14} />
                    <Legend
                        fontSize={14}
                        iconType="circle"
                        iconSize={11}
                        wrapperStyle={{ paddingTop: '15px' }}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default CognitiveAbilitiesBarChart;
